import { useCallback, useEffect, useRef, useState } from "react";
import recepcionistaDashboardService from "../services/recepcionistaDashboardService";

const emptyState = {
  kpis: [],
  cursos: [],
  proximas: [],
  sources: [],
  sourcesMonthly: [],
  lastUpdate: null,
};

export function useRecepcionistaDashboard() {
  const [state, setState] = useState(emptyState);
  const [loading, setLoading] = useState(false);
  const mountedRef = useRef(true);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    try {
      const payload = await recepcionistaDashboardService.fetch();
      if (!mountedRef.current) return;
      setState({
        kpis: payload?.kpis || [],
        cursos: payload?.cursos || [],
        proximas: payload?.proximas || [],
        sources: payload?.sources || [],
        sourcesMonthly: payload?.sourcesMonthly || [],
        lastUpdate: payload?.lastUpdate || null,
      });
    } catch (err) {
      console.error("Error cargando dashboard recepcionista", err);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    fetchDashboard();
    return () => {
      mountedRef.current = false;
    };
  }, [fetchDashboard]);

  return { ...state, loading, fetchDashboard };
}

export default useRecepcionistaDashboard;
